export default {
  okText: 'Ok',
  dismissText: 'Cancel',
  extra: 'please select'
};
